import { Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import PropTypes from "prop-types";
import { useState } from "react";
import { PostTeamCompetitionAnswers } from "../../functions/postData";
import { showNotification } from "../../functions/snackbar";
import AddPageWrapper from "../general/AddPageWrapper";
import InputContainer from "../general/InputContainer";
import ReusableButton from "../general/ReusableButton";
import ReusableTextField from "../general/ReusableTextField";
import TitleBar from "../general/TitleBar";

const sectionContainerStyle = { paddingBottom: 20 };
export default function Sets({ setsData, division, id }) {
  const sets = [
    setsData?.find((set) => set.set_number === 1) ?? { set_number: 1 },
    setsData?.find((set) => set.set_number === 2) ?? { set_number: 2 },
    setsData?.find((set) => set.set_number === 3) ?? { set_number: 3 },
    setsData?.find((set) => set.set_number === 4) ?? { set_number: 4 },
    setsData?.find((set) => set.set_number === 5) ?? { set_number: 5 },
  ];

  return (
    <Grid container style={sectionContainerStyle}>
      {sets?.map((set, index) => (
        <SetItem
          key={set.set_number}
          setNumber={set.set_number}
          setData={set}
          division={division}
          id={id}
        />
      ))}
    </Grid>
  );
}

const SetItem = ({ setNumber, setData, division, id }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [expand, setExpand] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [question1, setQuestion1] = useState(
    setData?.answer_keys ? setData?.answer_keys[0]?.answer_key : null
  );
  const [question2, setQuestion2] = useState(
    setData?.answer_keys ? setData?.answer_keys[1]?.answer_key : null
  );
  const [question3, setQuestion3] = useState(
    setData?.answer_keys ? setData?.answer_keys[2]?.answer_key : null
  );
  const [question4, setQuestion4] = useState(
    setData?.answer_keys ? setData?.answer_keys[3]?.answer_key : null
  );

  const [question1card1, setQuestion1card1] = useState(
    setData?.answer_keys?.[0]?.cards?.[0]
      ? setData.answer_keys[0].cards[0]
      : null
  );
  const [question1card2, setQuestion1card2] = useState(
    setData?.answer_keys?.[0]?.cards?.[1]
      ? setData.answer_keys[0].cards[1]
      : null
  );
  const [question1card3, setQuestion1card3] = useState(
    setData?.answer_keys?.[0]?.cards?.[2]
      ? setData.answer_keys[0].cards[2]
      : null
  );
  const [question1card4, setQuestion1card4] = useState(
    setData?.answer_keys?.[0]?.cards?.[3]
      ? setData.answer_keys[0].cards[3]
      : null
  );

  const [question2card1, setQuestion2card1] = useState(
    setData?.answer_keys?.[1]?.cards?.[0]
      ? setData.answer_keys[1].cards[0]
      : null
  );
  const [question2card2, setQuestion2card2] = useState(
    setData?.answer_keys?.[1]?.cards?.[1]
      ? setData.answer_keys[1].cards[1]
      : null
  );
  const [question2card3, setQuestion2card3] = useState(
    setData?.answer_keys?.[1]?.cards?.[2]
      ? setData.answer_keys[1].cards[2]
      : null
  );
  const [question2card4, setQuestion2card4] = useState(
    setData?.answer_keys?.[1]?.cards?.[3]
      ? setData.answer_keys[1].cards[3]
      : null
  );

  const [question3card1, setQuestion3card1] = useState(
    setData?.answer_keys?.[2]?.cards?.[0]
      ? setData.answer_keys[2].cards[0]
      : null
  );
  const [question3card2, setQuestion3card2] = useState(
    setData?.answer_keys?.[2]?.cards?.[1]
      ? setData.answer_keys[2].cards[1]
      : null
  );
  const [question3card3, setQuestion3card3] = useState(
    setData?.answer_keys?.[2]?.cards?.[2]
      ? setData.answer_keys[2].cards[2]
      : null
  );
  const [question3card4, setQuestion3card4] = useState(
    setData?.answer_keys?.[2]?.cards?.[3]
      ? setData.answer_keys[2].cards[3]
      : null
  );

  const [question4card1, setQuestion4card1] = useState(
    setData?.answer_keys?.[3]?.cards?.[0]
      ? setData.answer_keys[3].cards[0]
      : null
  );
  const [question4card2, setQuestion4card2] = useState(
    setData?.answer_keys?.[3]?.cards?.[1]
      ? setData.answer_keys[3].cards[1]
      : null
  );
  const [question4card3, setQuestion4card3] = useState(
    setData?.answer_keys?.[3]?.cards?.[2]
      ? setData.answer_keys[3].cards[2]
      : null
  );
  const [question4card4, setQuestion4card4] = useState(
    setData?.answer_keys?.[3]?.cards?.[3]
      ? setData.answer_keys[3].cards[3]
      : null
  );

  // Regex to validate numbers and fractions (e.g., 5, 3.14, 2/3, 1 1/2)
  const numberFractionRegex = /^(\d+(\.\d+)?|\d+\/\d+|\d+\s+\d+\/\d+)$/;

  // Function to validate and set state for number/fraction inputs
  const handleNumberFractionInput = (setter, value) => {
    // Allow empty values
    if (value === "") {
      setter(value);
      return;
    }

    // Allow typing numbers, fractions, and mixed numbers
    // This allows: "1", "1/", "1/2", "2", "2/", "2/3", "1 1/", "1 1/2"
    const partialFractionRegex = /^[\d\s/.]+$/;

    if (partialFractionRegex.test(value)) {
      setter(value);
    }
  };

  const onSubmit = () => {
    const payload = {
      set_number: setNumber,
      division: division,
      answer_keys: [
        {
          question_number: 1,
          answer_key: question1,
          cards: [
            question1card1,
            question1card2,
            question1card3,
            question1card4,
          ],
        },
        {
          question_number: 2,
          answer_key: question2,
          cards: [
            question2card1,
            question2card2,
            question2card3,
            question2card4,
          ],
        },
        {
          question_number: 3,
          answer_key: question3,
          cards: [
            question3card1,
            question3card2,
            question3card3,
            question3card4,
          ],
        },
        {
          question_number: 4,
          answer_key: question4,
          cards: [
            question4card1,
            question4card2,
            question4card3,
            question4card4,
          ],
        },
      ],
    };

    PostTeamCompetitionAnswers(id, payload).then((res) => {
      if (res.error) {
        showNotification("warning", res.error, enqueueSnackbar, closeSnackbar);
      } else {
        showNotification(
          "success",
          res.message,
          enqueueSnackbar,
          closeSnackbar
          // onConfirm()
        );
      }
    });
  };
  return (
    <Grid container>
      <TitleBar
        title={`Set ${setNumber}`}
        state={expand}
        setState={setExpand}
      ></TitleBar>
      {expand && (
        <AddPageWrapper>
          <InputContainer
            label=""
            field={
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 10,
                  marginBottom: -20,
                }}
              >
                <h3 style={{ width: "150px", textAlign: "center" }}>
                  Key Answer
                </h3>
                <div
                  style={{
                    width: "4%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 2,
                      height: 50,
                      backgroundColor: "#000",
                    }}
                  />
                </div>
                <h3 style={{ width: "600px", textAlign: "center" }}>Cards</h3>
              </div>
            }
          />
          <InputContainer
            label="Question 1*"
            field={
              <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Question 1*"
                  disabled={false}
                  state={question1}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion1, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />

                <div
                  style={{
                    width: "4%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 2,
                      height: 50,
                      backgroundColor: "#000",
                    }}
                  />
                </div>
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 1"
                  disabled={false}
                  state={question1card1}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion1card1, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 2"
                  disabled={false}
                  state={question1card2}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion1card2, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 3"
                  disabled={false}
                  state={question1card3}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion1card3, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 4"
                  disabled={false}
                  state={question1card4}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion1card4, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
              </div>
            }
          />
          <InputContainer
            label="Question 2*"
            field={
              <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Question 2*"
                  disabled={false}
                  state={question2}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion2, value)
                  }
                  head="settingText"
                  required
                  // number
                />
                <div
                  style={{
                    width: "4%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 2,
                      height: 50,
                      backgroundColor: "#000",
                    }}
                  />
                </div>
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 1"
                  disabled={false}
                  state={question2card1}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion2card1, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 2"
                  disabled={false}
                  state={question2card2}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion2card2, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 3"
                  disabled={false}
                  state={question2card3}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion2card3, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 4"
                  disabled={false}
                  state={question2card4}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion2card4, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
              </div>
            }
          />
          <InputContainer
            label="Question 3*"
            field={
              <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Question 3*"
                  disabled={false}
                  state={question3}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion3, value)
                  }
                  head="settingText"
                  required
                  // number
                />
                <div
                  style={{
                    width: "4%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 2,
                      height: 50,
                      backgroundColor: "#000",
                    }}
                  />
                </div>
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 1"
                  disabled={false}
                  state={question3card1}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion3card1, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 2"
                  disabled={false}
                  state={question3card2}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion3card2, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 3"
                  disabled={false}
                  state={question3card3}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion3card3, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 4"
                  disabled={false}
                  state={question3card4}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion3card4, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
              </div>
            }
          />
          <InputContainer
            label="Question 4*"
            field={
              <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Question 4*"
                  disabled={false}
                  state={question4}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion4, value)
                  }
                  head="settingText"
                  required
                  // number
                />
                <div
                  style={{
                    width: "4%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 2,
                      height: 50,
                      backgroundColor: "#000",
                    }}
                  />
                </div>
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 1"
                  disabled={false}
                  state={question4card1}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion4card1, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 2"
                  disabled={false}
                  state={question4card2}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion4card2, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 3"
                  disabled={false}
                  state={question4card3}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion4card3, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
                <ReusableTextField
                  type="default"
                  width={150}
                  bgColor="#F2F2F2"
                  placeholder="Card 4"
                  disabled={false}
                  state={question4card4}
                  setState={(value) =>
                    handleNumberFractionInput(setQuestion4card4, value)
                  }
                  head="settingText"
                  // target={`question${setNumber}`}
                  required
                  // number
                />
              </div>
            }
          />

          {!isReadOnly && (
            <Grid
              container
              justifyContent="flex-end"
              style={{ margin: " 20px" }}
            >
              <ReusableButton
                text="Save"
                bgColor="#5E75C3"
                fontSize={16}
                onClick={() => onSubmit()}
              />
            </Grid>
          )}
        </AddPageWrapper>
      )}
    </Grid>
  );
};

SetItem.propTypes = {
  setNumber: PropTypes.number.isRequired,
};
